import * as React from 'react';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { CheckOutType } from '../../models/common/CheckOutType';
import { useHistory } from 'react-router';

export const NavigateCheckOutStart = () => {
    let history = useHistory();
    const checkOutState = React.useContext(CheckOutStateContext);

    if (checkOutState.state.checkOutType === CheckOutType.TextToPay || 
        checkOutState.state.checkOutType === CheckOutType.GrabNGo) {
        history.push('/checkout/checkout?c=' + checkOutState.state.checkOutType!!.toString() + '&i=' + checkOutState.state.checkInId!!.toString());
    }
    else if (checkOutState.state.checkOutType === CheckOutType.ScanToPay) {
        history.push('/checkout/checkout?c=' + checkOutState.state.checkOutType!!.toString() + '&r=' + checkOutState.state.restaurantId!!.toString() + '&t=' + checkOutState.state.tableId!!.toString());
    }
    else if (checkOutState.state.checkOutType === CheckOutType.ScanReceiptToPay) {
        history.push('/checkout/checkout?c=' + checkOutState.state.checkOutType!!.toString() + '&r=' + checkOutState.state.restaurantId!!.toString() + '&t=' + checkOutState.state.receiptCheckExternalId!!.toString());
    }
}